/** Opciones del selector «Ventas por página» (mismo set que usePaginatedRemoteList). */
export const SALES_LIST_PAGE_SIZE_OPTIONS = [5, 10, 25, 50] as const;

export type SalesListPageSize = (typeof SALES_LIST_PAGE_SIZE_OPTIONS)[number];

/** Tamaño por defecto para listados paginados de ventas (menos paginación a ciegas). */
export const SALES_LIST_PAGE_SIZE: SalesListPageSize = 25;
